import { http } from "services/http";
import axios from "axios";

export const getOrganizations = async (sda) => {
  try {
    const response = await http.get(
      `/api/organizations/Organizations?sda=${sda ? 1 : 0}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getOrganizationProfile = async (organizationId) => {
  try {
    const response = await http.get(
      `/api/organization_profile/${organizationId}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOrganizationCurrentEmployees = async (organizationId) => {
  try {
    const response = await http.get(
      `/api/organization_profile/current_employees/${organizationId}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOrganizationFormerEmployees = async (organizationId) => {
  try {
    const response = await http.get(
      `/api/organization_profile/former_employees/${organizationId}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const setEmployeeUnverified = async (employmentId) => {
  try {
    const payload = new FormData();
    payload.append("employment_id", employmentId);
    const response = await http.post(
      `/organization_profile/set_employee_unverified`,
      payload,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return response;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const setEmployeeVerified = async (employmentId) => {
  try {
    const response = await http.get(
      `/organization_profile/set_employee_verification_status?user_employment_id=${employmentId}&status=1`,
    );
    return response;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const endEmployment = async (employmentId, terminationDate) => {
  try {
    const payload = new FormData();
    payload.append("employment_record_id", employmentId);
    payload.append("termination_date", terminationDate);
    await http.post("/organization_profile/fire_employee", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const setEmployeeECEGrantee = async (employmentId, granteeStatus) => {
  try {
    const payload = new FormData();
    payload.append("employment_record_id", employmentId);
    payload.append("grantee_status", granteeStatus);

    await http.post(
      "/organization_profile/update_employee_ece_grantee",
      payload,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
  } catch (error) {
    console.error("Error updating OPP Grantee status:", error);
    return { status: "error", message: error.message };
  }
};

export const getPaymentInfo = async (organizationId) => {
  try {
    const response = await http.get(`/api/payments/pp_info/${organizationId}`);
    return response.data.org;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOrgPayments = async (organizationId) => {
  try {
    const response = await http.get(
      `/api/payments/org_payments?oin=${organizationId}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOrgRepayments = async (organizationId) => {
  try {
    const response = await http.get(
      `/api/payments/org_repayments?oin=${organizationId}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOrgApplications = async (organizationId) => {
  try {
    const response = await http.get(
      `/api/organization_profile/applications/${organizationId}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getCurrentEmployeesByLicense = async (licenseNumber) => {
  try {
    const response = await http.get(
      `/api/current_employees/current_employees_list/${licenseNumber}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getPaymentsPPInfo = async (organizationId) => {
  try {
    const response = await http.get(`/api/payments/pp_info/${organizationId}`);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getODHCurrentEmployees = async (licenseNumber) => {
  try {
    const response = await http.get(
      `/api/current_employees/odh_current_employees/${licenseNumber}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getDODDCurrentEmployees = async (licenseNumber) => {
  try {
    const response = await http.get(
      `/api/current_employees/dodd_current_employees/${licenseNumber}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getOrganization1099s = async (licenseNumber) => {
  try {
    const response = await http.get(
      `/api/organizations/organizations/org1099s/${licenseNumber}`,
    );
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getNewHireFormSchemaAndData = async (
  orgType,
  userId,
  licenseNumber,
) => {
  try {
    const data = await http.get(`/api/checklist/form_schema_and_data`, {
      params: {
        userId,
        licenseNumber,
        orgType,
      },
    });
    return data.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const postNewHireFormData = async (userId, licenseNumber, data) => {
  try {
    const response = await http.post(`/api/Checklist/form_data`, {
      userId,
      licenseNumber,
      data,
    });
    return response;
  } catch (ex) {
    console.log(ex);
  }
};

export const getNewHireFormCenterTypes = async () => {
  try {
    const response = await http.get(`/api/Checklist/center_types`);
    const resArray = response.data.data.split(",");
    return resArray;
  } catch (ex) {
    console.log(ex);
  }
};

export const getMentorApplication = async (
  oin,
  action,
  appId,
  mentorshipType,
) => {
  try {
    const res = await http.get(`/api/mentor_application`, {
      params: {
        oin,
        action,
        appId,
        mentorshipType,
      },
    });

    return res.data;
  } catch (ex) {
    return { error: true, message: "Failed to retrieve application." };
  }
};

export const saveMentorApplication = async (app, isAdmin = false) => {
  try {
    const res = await http.put(
      `/api/mentor_application/${isAdmin ? "admin" : ""}`,
      { app },
    );
    return res.data;
  } catch (ex) {
    return { error: true, message: "Failed to save application." };
  }
};

export const submitMentorApplication = async (app) => {
  try {
    const res = await http.post(`/api/mentor_application/submit`, { app });
    return res.data;
  } catch (ex) {
    return { error: true, message: "Failed to submit application." };
  }
};

export const getOHPApplication = async (oin, action, appId) => {
  try {
    const res = await http.get(`/api/ohp_application`, {
      params: {
        id: appId,
        oin,
        action,
      },
    });
    return res.data;
  } catch (e) {
    return { error: true, message: "Failed to retrieve application." };
  }
};

export const uploadOHPMessage = async (message) => {
  try {
    const res = await http.post(`/api/ohp_application/communicationLog`, {
      message,
    });
    return res.data;
  } catch (e) {
    console.error("Error uploading message:", e);
    return { error: true, message: "Failed to upload message." };
  }
};

export const uploadOHPFiles = async (formData) => {
  try {
    const res = await axios.post(`/api/ohp_application/file`, formData);
    return res.data;
  } catch (e) {
    console.error("Error uploading files:", e);
    return { error: true, message: "Failed to upload files." };
  }
};

export const saveOHPApplication = async (ohp_app, isAdmin) => {
  try {
    const res = await http.put(
      `/api/ohp_application${isAdmin ? "/admin" : ""}`,
      { ohp_app },
    );
  } catch (e) {
    return { error: true, message: "Falied to save application" };
  }
};
